var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1954_1608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 7.94245C13.3603 7.80932 13.3335 7.67746 13.2806 7.55527C13.2278 7.43308 13.1501 7.32322 13.0525 7.23269L7.12502 1.76562L1.19757 7.23269C1.09995 7.32322 1.02225 7.43308 0.969411 7.55527C0.91657 7.67746 0.889746 7.80932 0.890647 7.94245V13.2752C0.890647 13.5296 0.991698 13.7736 1.17157 13.9534C1.35144 14.1333 1.59541 14.2344 1.84978 14.2344H12.4002C12.6546 14.2344 12.8986 14.1333 13.0784 13.9534C13.2584 13.7736 13.3594 13.5296 13.3594 13.2752V7.94245Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.33594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.2343V10.3978",
    stroke: "#EFFEF5",
    strokeWidth: 1.33594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1954_1608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.25,
    height: 14.25,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.502176b85a6a5654aabe71de2f9354a6.svg";
export { ForwardRef as ReactComponent };